<template>
  <div id="app">
    <SiteHeader v-on:toggle-drawer="drawer = $event" />
    <router-view />
    <SiteFooter />
  </div>
</template>

<script>
import SiteHeader from "./components/SiteHeader";
import SiteFooter from "./components/SiteFooter";

export default {
  name: "App",

  components: {
    SiteHeader,
    SiteFooter
  },

  data: () => ({
    drawer: false,
    fab: false,
    loggedIn: false
  }),
  methods: {
    //
  }
};
</script>
